import { api } from '@/services/api/main/axios';

export const putUserDomainDataApiRequest = async (params: {
  redirectDomainId?: string;
  trackingDomainId?: string;
  rootDomain?: string;
  rootRedirect?: string;
}): Promise<Bemob.RedirectDomain[]> => {
  const res = await api.put<{ payload: Bemob.RedirectDomain[] }>('user', params);
  return res.data.payload;
};

export const postCheckTrackingDomainDnsApiRequest = async (payload: unknown) => {
  const res = await api.post<{ payload: any }>('user/tracking-domains/check-dns', payload);
  return res.data.payload;
};

export const postCreateTrackingDomainApiRequest = async (payload: { domain: string }) => {
  const res = await api.post<{ payload: unknown }>('user/tracking-domains', payload);
  return res.data.payload;
};

export const postCreateRedirectDomainApiRequest = async (payload: { domain: string }) => {
  const res = await api.post<{ payload: unknown }>('user/redirect-domains', payload);
  return res.data.payload;
};

export const getTrackingDomainApiRequest = async (id: string) => {
  return api.get(`user/tracking-domains/${id}`);
};

export const deleteTrackingDomainApiRequest = async (id: string) => {
  const res = await api.delete<{ payload: unknown }>(`user/tracking-domains/${id}`);
  return res.data.payload;
};

export const getTrackingDomainsApiRequest = async (params: Record<string, unknown> = {}) => {
  try {
    const res = await api.get<{ payload: unknown }>('user/tracking-domains', { params });
    return res.data.payload;
  } catch {
    return Promise.reject();
  }
};

export const getRedirectDomainsApiRequest = async (params: Record<string, unknown> = {}) => {
  try {
    const res = await api.get<{ payload: unknown }>('user/redirect-domains', { params });
    return res.data.payload;
  } catch {
    return Promise.reject();
  }
};

export const putTrackingDomainApiRequest = async (id: string, payload: unknown) => {
  const res = await api.put<{ payload: unknown }>(`user/tracking-domains/${id}`, payload);
  return res.data.payload;
};

export const postCheckRedirectDomainDnsApiRequest = async (payload: unknown) => {
  const res = await api.post<{ payload: any }>('user/redirect-domains/check-dns', payload);
  return res.data.payload;
};

export const getRedirectDomainApiRequest = async (id: string) => {
  return api.get(`user/redirect-domains/${id}`);
};

export const deleteRedirectDomainApiRequest = async (id: string) => {
  const res = await api.delete<{ payload: unknown }>(`user/redirect-domains/${id}`);
  return res.data.payload;
};

export const getFindRedirectDomainsApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<Bemob.RedirectDomain[]> => {
  try {
    const res = await api.get<{ payload: Bemob.RedirectDomain[] }>('user/redirect-domains', { params });
    return res.data.payload;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};
